import { Box, InputAdornment, TextField } from '@mui/material';

import { IconSearchMS } from '../../../constants/icons';
import {
  SectionIndexGroupLabel,
  SectionIndexGroupList,
  SectionIndexOptionLabel,
  SectionIndexOptionSubLabel,
  StyledSectionIndexAutocomplete,
  StyledSectionIndexPaper,
} from '../styles';

export function scrollToId(id: string, offset = 20): void {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: 'smooth' });
}

export interface SectionIndexItem {
  label: string;
  sectionLabel: string;
  sectionId: string;
  tabKey: string;
  tabLabel: string;
}

interface SectionIndexAutocompleteProps {
  options: SectionIndexItem[];
  onNavigate: (item: SectionIndexItem) => void;
}

export function SectionIndexAutocomplete({
  options,
  onNavigate,
}: SectionIndexAutocompleteProps): JSX.Element {
  return (
    <StyledSectionIndexAutocomplete<SectionIndexItem>
      PaperComponent={StyledSectionIndexPaper}
      options={options}
      groupBy={(item) => item.tabLabel}
      getOptionLabel={(item) => item.label}
      renderGroup={(params) => (
        <Box key={params.key} component="li">
          <SectionIndexGroupList component="ul">
            <SectionIndexGroupLabel>{params.group}</SectionIndexGroupLabel>
            {params.children}
          </SectionIndexGroupList>
        </Box>
      )}
      renderOption={(props, item) => (
        <Box component="li" {...props}>
          <Box>
            <SectionIndexOptionLabel component="span">
              {item.label}
            </SectionIndexOptionLabel>
            {item.label !== item.sectionLabel && (
              <SectionIndexOptionSubLabel component="span">
                {item.sectionLabel}
              </SectionIndexOptionSubLabel>
            )}
          </Box>
        </Box>
      )}
      onChange={(_, value) => {
        if (value) onNavigate(value as SectionIndexItem);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Pesquisar em todas as abas"
          color="secondary"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start" sx={{ color: 'primary.main' }}>
                {IconSearchMS}
              </InputAdornment>
            ),
          }}
        />
      )}
      clearOnBlur
      blurOnSelect
    />
  );
}
